
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phongvu/desktop/products/detail/[productId]",
      function () {
        return require("private-next-pages/phongvu/desktop/products/detail/[productId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phongvu/desktop/products/detail/[productId]"])
      });
    }
  